import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'react-hot-toast'
import App from './App.jsx'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (failureCount, error) => {
        if (error?.response?.status === 401) return false
        if (error?.response?.status === 404) return false
        return failureCount < 2
      },
      refetchOnWindowFocus: false,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              background: 'rgb(var(--surface-2))',
              color: 'rgb(var(--text-primary))',
              border: '1px solid rgb(var(--border))',
              borderRadius: '12px',
              fontSize: '14px',
              boxShadow:
                'inset 0 1px 0 0 rgb(var(--highlight) / var(--highlight-a)), 0 12px 32px -18px rgb(0 0 0 / 0.55)',
            },
            success: {
              iconTheme: { primary: 'rgb(var(--ok))', secondary: 'rgb(var(--surface-2))' },
            },
            error: {
              iconTheme: { primary: 'rgb(var(--danger))', secondary: 'rgb(var(--surface-2))' },
            },
          }}
        />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)
